import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-window-restore",
  "use": "icon-window-restore-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol fill=\"#000000\" viewBox=\"0 0 36 36\" preserveAspectRatio=\"xMidYMid meet\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-window-restore\">\n    <title>window-restore-line</title>\n    <path d=\"M28,8H14a2,2,0,0,0-2,2v2h2V10H28V20H26v2h2a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8Z\" class=\"clr-i-outline clr-i-outline-path-1\" /><path d=\"M22,14H8a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V16A2,2,0,0,0,22,14ZM8,26V16H22V26Z\" class=\"clr-i-outline clr-i-outline-path-2\" />\n    <rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" fill-opacity=\"0\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/window-restore.svg
// module id = ardY
// module chunks = 84